import { render } from "./SliderBoxingView.vue?vue&type=template&id=49b18066&scoped=true"
import script from "./SliderBoxingView.vue?vue&type=script&lang=js"
export * from "./SliderBoxingView.vue?vue&type=script&lang=js"

import "./SliderBoxingView.vue?vue&type=style&index=0&id=49b18066&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b18066"]])

export default __exports__